<template>
  <div class="cartContainer">
    <div v-if="goods.length == 0"
         class="index-empty">
      <div class="index-empty-box">
        <div class="imageEmptyCart">
          <img src="../../../assets/images/cart.png"
               alt />
        </div>
        <div style="padding: 2vw 0 5vw">购物车中没有商品</div>
        <div>
          <van-button plain
                      hairline
                      type="primary"
                      size="small"
                      @click="onGoShopClick()">去逛逛</van-button>
        </div>
      </div>
    </div>
    <div v-if="goods.length > 0"
         class="scroll">
      <div class="flex-around">
        <div class="flex-center">
          <div class="cartTip"></div>
          7天无理由退换
        </div>
        <div class="flex-center">
          <div class="cartTip"></div>
          当天快速退款
        </div>
        <div class="flex-center">
          <div class="cartTip"></div>
          微信认证
        </div>
      </div>
      <!-- <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="height: 100%; overflow: auto"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="到底啦~"
          @load="onLoad"
          :immediate-check="false"
          class="cartList"
        > -->
      <div class="cartList"
           style="height: 100%; overflow-y: auto;overflow-x: hidden;">
        <div class="list-item"
             v-for="item,index in cartlistAvailable"
             :key="item.id"
             data-type="0">
          <van-swipe-cell>
            <div style="padding: 2vw 4vw">
              <van-checkbox-group class="card-goods"
                                  v-model="checkedGoods"
                                  checked-color="#ff6274">
                <!-- @click="onStatusChange(item.id,item.checked)" -->
                <van-checkbox class="card-goods__item"
                              :name="item.id"
                              v-model="item.checked"
                              @click="onStatusChange(item.id, item.checked)"
                              checked-color="#ff6274">
                </van-checkbox>
                <van-card :title="item.goodsName"
                          :desc="item.specificationNames"
                          :num="item.quantity"
                          :price="formatPrice(item.retailPrice)"
                          :thumb="item.pictureUrl"
                          class="card_shop">
                  <!--更改 直观显示加减  -->
                  <div slot="num">
                    <!-- {{ item }} -->
                    <van-stepper v-model="item.quantity"
                                 :max="item.limitQuantity !== undefined&&!item.isExpired? item.limitQuantity - item.userLimit : 100"
                                 :min="1"
                                 @change="onQuantityChange(item.quantity, item,index)"
                                 integer
                                 :allow-empty="true"
                                 async-change />
                  </div>

                  <template #price>
                    <div style="font-size: 18px">
                      ￥{{ formatPrice(item.retailPrice) }}
                      <!-- <span class="linePrice">￥{{ item.costPrice }}</span> -->
                    </div>
                  </template>
                </van-card>
                <!-- <div class="flex-row" v-if="item.checked">
                <van-tag color="#ee0a24" plain>本店活动</van-tag>
                <div style="margin-left:2vw;">{{item.basketCouponDto.couponNo}}</div>
              </div>-->
              </van-checkbox-group>
            </div>
            <template #right>
              <van-button square
                          text="删除"
                          type="danger"
                          class="delete-button"
                          @click='deleteItem(item, item.id)' />
            </template>
          </van-swipe-cell>
        </div>
        <div v-if="cartlistUnabled.length > 0">
          <div class="packageActive">
            <div class="describe">下架产品</div>
            <div class="panelStatus"
                 @click="clearClick">清空</div>
          </div>
          <div class="list-item"
               v-for="item in cartlistUnabled"
               :key="item.id">
            <div class="clearGoods">
              <van-checkbox-group class="card-goods">
                <div style="width: 100%">
                  <van-checkbox disabled
                                class="card-goods__item"
                                :name="item.id">
                    <van-card :title="item.goodsName"
                              :desc="item.specificationNames"
                              :thumb="item.pictureUrl"
                              :price="formatPrice(item.retailPrice)"
                              class="card_shop">
                      <template #price>
                        <div style="font-size: 18px">
                          ￥{{ formatPrice(item.retailPrice) }}
                        </div>
                      </template>
                      <!-- <div slot="num">
                    <van-stepper
                      v-model="i.quantity"
                      @change="onQuantityChange"
                      integer
                    />
                  </div> -->
                    </van-card>
                  </van-checkbox>
                </div>
              </van-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <!-- </van-list>
      </van-pull-refresh> -->
    </div>
    <van-submit-bar class="cart-submit"
                    :price="totalPrice"
                    :disabled="!checkedGoods.length"
                    :button-text="submitBarText"
                    square
                    @submit="onSubmitDialog"
                    :safe-area-inset-bottom="true"
                    :loading="loading">
      <van-checkbox class="cart-check-all"
                    v-model="isCheckedAll"
                    @click="allChecked"
                    checked-color="#ff6274">全选
      </van-checkbox>

      <!-- <div style="line-height: 100%; margin-left: 2vw" @click="onEdit">
        {{ editButtonText }}
      </div> -->
      <!-- 编辑操作修改成删除 -->
      <div class="deleteAll"
           @click="onDelete"
           v-if="checkedGoods.length > 0">
        删除
      </div>
    </van-submit-bar>
    <van-dialog v-model="close"
                confirmButtonText="我知道了"
                cancelButtonColor="#9c9c9c"
                @confirm="onClose"
                v-if="AgentIsShow">
      <div class="flexCenter"
           style="padding: 32px 42px;font-size: 14px;flex-wrap: wrap;">
        <div>您正在为「</div>
        <div class="ellipsisText ellipsisDisabledWidth">{{ agentShow.address.nickName }}</div>
        <div>」代买</div>
      </div>
    </van-dialog>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Button,
  Stepper,
  List,
  PullRefresh,
  Tag,
  Toast,
  Dialog,
  Overlay,
  SwipeCell
} from "vant";
import { mapGetters, mapActions } from "vuex";
import service from "../../api/cart/index";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Stepper.name]: Stepper,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Overlay.name]: Overlay,
    [SwipeCell.name]: SwipeCell,
    loading,
  },

  data () {
    return {
      close: false,
      disX: 0,
      moveX: 0,
      startX: 0, // 滑动开始位置
      endX: 0,  // 滑动结束位置
      isLoading: true, //loading状态
      checkedGoods: [],
      cartlistAvailable: [], //上架商品
      cartlistUnabled: [], //下架商品
      goods: [
        {
          id: "1",
          goodsId: 0,
          goodsName: "",
          pictureUrl: "",
          quantity: 0,
          specificationNames: "",
          retailPrice: 0,
        },
      ],
      isEdit: false,
      editButtonText: "编辑",
      showEmpty: false,
      loading: false,
      // finished: false,
      // refreshing: false,
      firstLoading: false,
      // page: 1,
      // pageSize: 10,
      isCheckedShow: false,
      limitGoodsList: []
    };
  },

  computed: {
    submitBarText () {
      // const count = this.checkedGoods.length;
      const count = this.cartlistAvailable.reduce(
        (total, item) =>
          total +
          (this.checkedGoods.indexOf(item.id) !== -1 ? item.quantity : 0),
        0
      );
      return "下单" + (count ? `(${count})` : "");
      // 注释所选件数
      // if (this.isEdit) {
      //   return "删除所选" + (count ? `(${count})` : "") + "件";
      // } else {
      //   return "下单" + (count ? `(${count})` : "");
      // }
    },
    cartGoodsChecked () {
      let checked;
      this.cartlistAvailable.map((item) => {
        if (this.checkedGoods.indexOf(item.id) !== -1) {
          checked = true;
        } else {
          checked = false;
        }
      });
      return checked;
    },
    totalPrice () {
      return this.cartlistAvailable.reduce(
        (total, item) =>
          total +
          (this.checkedGoods.indexOf(item.id) !== -1
            ? item.retailPrice * item.quantity * 100
            : 0),
        0
      );
    },
    isCheckedAll: {
      get () {
        if (this.cartlistAvailable.length > 0) {
          return this.checkedGoods.length == this.cartlistAvailable.length;
        } else {
          return false
        }
      },
      set (val) {
        if (!val) {
          this.checkedGoods = [];
        } else {
          let goodsChecked = [];
          this.cartlistAvailable.map((item) => {
            // if (item.isExpired) {
            // } else {
            //   goodsChecked.push(item.id);
            // }
            goodsChecked.push(item.id);
          });
          this.checkedGoods = goodsChecked;
        }
      },
    },
    ...mapGetters(["userInfo", "cartInfo", "agentShow"]),
    AgentIsShow () {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },

  methods: {

    // 滑动删除
    deleteItem (item, id) {
      console.log(item, id, 299)
      let basketId = [
        {
          id: id
        }
      ];
      Dialog.confirm({
        message: "确认删除么",
      })
        .then(() => {
          service.deleteCart(basketId).then((response) => {
            Toast("删除成功");
            this.init();
            this.updateUserCartQuantity(
              this.cartInfo - 1
            );
            this.goods = this.goods.filter((item) => {
              return id.indexOf(item.id) < 0;
            });
          });
        })
        .catch(() => {
          Toast("你已取消删除");
        });

    },
    // 选中删除
    onDelete () {
      // this.checkedGoods.join(",")
      var basketNumber = [];
      this.checkedGoods.map((i) => {
        basketNumber.push({ id: i });
      });
      Dialog.confirm({
        message: "确认删除么",
      })
        .then(() => {
          service.deleteCart(basketNumber).then((response) => {
            Toast("删除成功");
            this.init();
            this.updateUserCartQuantity(
              this.cartInfo - this.checkedGoods.length
            );
            this.goods = this.goods.filter((item) => {
              return this.checkedGoods.indexOf(item.id) < 0;
            });
            this.checkedGoods = [];
          });
        })
        .catch(() => {
          Toast("你已取消删除");
        });
    },
    // 全选
    allChecked () {
      if (this.cartlistAvailable.length !== 0) {
        service.allchecked(this.cartGoodsChecked).then((res) => {
          this.init();
        });
      }
    },
    ...mapActions(["updateUserCartQuantity"]),
    onGoShopClick () {
      this.$router.push({ name: "page" });
    },
    formatPrice (price) {
      if (price >= 1) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    // 限购商品
    GetLimitGoods (goodsId) {
      service.GetLimitGoodsDetail(goodsId).then((res) => {
        console.log(res, 411);
        setTimeout(() => {
          this.isLoading = false;
        }, 500);

        this.cartlistAvailable.map((v) => {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].goodsId == v.goodsId) {
              v.limitQuantity = res.data[i].limitQuantity;
              v.userLimit = res.data[i].userLimit;
              v.isExpired = res.data[i].isExpired;

            }
          }
        });
        // this.cartlistAvailable.map(j => {
        //   if (j.isExpired !== true) {
        //     this.limitGoodsList.push(j)
        //   }
        // });
      });
    },
    // 修改购物车数量
    onQuantityChange (e, key, index) {
      console.log(e, key, index, 386)
      // debugger
      this.isLoading = true;
      var limitNum = key.limitQuantity - key.userLimit;
      console.log(key.limitQuantity, "key.limitQuantity");
      if (key.limitQuantity !== undefined&&!key.isExpired) {
        if (key.quantity > limitNum) {
          e = limitNum;
          console.log(limitNum, 394)
          setTimeout(() => {
            this.isLoading = false;
            // 再次触发 change 事件
            this.cartlistAvailable[index].quantity = limitNum
            this.$set(this.cartlistAvailable, index, this.cartlistAvailable[index])
          }, 500);
          // this.cartlistAvailable.map((v) => {
          //   if (key.goodsId == v.goodsId) {
          //     v.quantity = limitNum;
          //   }
          // });
          console.log(this.cartlistAvailable, "this.cartlistAvailablethis.cartlistAvailable")
          Toast(`该商品限购${key.limitQuantity}件,剩余可购买${key.limitQuantity - key.userLimit}件`);
        } else {
          this.isLoading = false;
           if (e !== '' && e !== undefined && e !== null) {
            this.isLoading = false;
            console.log(key, "onQuantityChange");
            service.updateCartNumber({ quantity: e, id: key.id });
          } else {
            e = 1
            setTimeout(() => {
              this.isLoading = false;
              // 注意此时 会再次触发 change 事件
              this.cartlistAvailable[index].quantity = 1
              this.$set(this.cartlistAvailable, index, this.cartlistAvailable[index])
            }, 500);
            service.updateCartNumber({ quantity: e, id: key.id });
          }
        }
      } else {

        if (e > 100) {
          e = 100;
          setTimeout(() => {
            this.isLoading = false;
            // 注意此时 会再次触发 change 事件
            this.cartlistAvailable[index].quantity = 100
            this.$set(this.cartlistAvailable, index, this.cartlistAvailable[index])
          }, 500);
          console.log(e, index, this.cartlistAvailable[index], 306);
          Toast("购买数量不能超过100件");
        } else {
          if (e !== '' && e !== undefined && e !== null) {
            console.log(e, "CESHI ")
            console.log(e, "test")
            this.isLoading = false;
            console.log(key, "onQuantityChange");
            service.updateCartNumber({ quantity: e, id: key.id });
          } else {
            e = 1
            setTimeout(() => {
              this.isLoading = false;
              // 注意此时 会再次触发 change 事件
              this.cartlistAvailable[index].quantity = 1
              this.$set(this.cartlistAvailable, index, this.cartlistAvailable[index])
            }, 500);
          }
        }
      }
    },
    // 注释编辑
    // onEdit() {
    //   if (this.isEdit) {
    //     this.isEdit = false;
    //     this.editButtonText = "编辑";
    //     this.isLoading = true;
    //     setTimeout(() => {
    //       this.isLoading = false;
    //     }, 800);
    //     // 遍历传每个商品传参
    //     // this.goods.map(i=>{
    //     //   console.log(i.quantity,"i.quantit")
    //     //   if(i.quantity>=100){
    //     //     Toast("购物车每件商品购买数量不能超过100件");
    //     //     i.quantity = 100
    //     //   }
    //     //   service.updateCartNumber({ quantity: i.quantity, id: i.id });
    //     // })
    //   } else {
    //     this.isEdit = true;
    //     this.editButtonText = "完成";
    //   }
    // },
    // 单个选中上架商品
    onStatusChange (e, checked, isExpired) {
      console.log(isExpired, "isExpired")
      // if (isExpired) {
      //   Toast('活动已截止')
      //   return
      // }
      let singleChecked = {};
      this.cartlistAvailable.map((v) => {
        if (e == v.id) {
          v.checked = !checked;
          singleChecked = { id: e, checked: v.checked };
        }
      });
      service.checked(singleChecked);
    },
    // 清除全部下架商品
    clearClick () {
      service.EmpltyDeleted().then((res) => {
        console.log(res, "清空");
        if (res.statusCode == 200) {
          this.init();
        }
      });
    },
    onSubmitDialog () {
      // 默认普通订单
      if (this.AgentIsShow == false) {
        // win 新人大礼包修改 下单前看绑定用户能否下单
        if (this.userInfo.userType !== "common" ||
          this.userInfo.statusName !== "limited") {
          service.IsCartActivity().then((res) => {
            if (res.statusCode == 200 && !res.data) {
              this.onSubmit()
            } else {
              Dialog.alert({
                title: '无法下单',
                message: "您有待付款订单，无法下单",
                messageAlign: 'center',
                showCancelButton: true,
                confirmButtonText: '去付款',
                cancelButtonText: "取消"
              }).then(() => {
                // win 去付款页面
                this.$router.replace({
                  name: "orderDetail",
                  query: { id: res.data },
                });
              });
            }
          }).catch(err => {
            // Toast(err);
          });
        } else {
          this.onSubmit()
        }
      } else {
        this.close = true
      }
    },
    // 知道了后掉接口
    onClose () {
      this.onSubmit()
    },
    onSubmit () {
      this.$log.debug("test", this.checkedGoods);
      // 修改 不在提交内删除 
      // if (this.isEdit) {
      //   // this.checkedGoods.join(",")
      //   var basketNumber = [];

      //   this.checkedGoods.map((i) => {
      //     basketNumber.push({ id: i });
      //   });
      //   Dialog.confirm({
      //     message: "确认删除么",
      //   })
      //     .then(() => {
      //       service.deleteCart(basketNumber).then((response) => {
      //         Toast("删除成功");
      //         this.init();
      //         this.updateUserCartQuantity(
      //           this.cartInfo - this.checkedGoods.length
      //         );
      //         this.goods = this.goods.filter((item) => {
      //           return this.checkedGoods.indexOf(item.id) < 0;
      //         });
      //         this.checkedGoods = [];
      //       });
      //     })
      //     .catch(() => {
      //       Toast("你已取消删除");
      //     });
      // } 

      if (!this.userInfo.phoneNumber) {
        Dialog.alert({
          title: "提示",
          message: "只有绑定手机号码才能购买哦",
        }).then(() => {
          this.$router.push("setting");
        });
        return;
      }

      // this.goods.map(i=>{
      //   console.log(i.quantity,"i.quantit")
      //   if(i.quantity>=100){
      //     Toast("购物车每件商品购买数量不能超过100件");
      //     i.quantity = 100
      //     return
      //   }
      // })
      console.log(this.checkedGoods, this.limitGoodsList, "this.checkedGoods")
      // if (this.limitGoodsList.length > 0) {
      //   this.limitGoodsList.map(v => {
      //     if (v.checked && v.isExpired) {
      //       Toast('选中商品有促销产品，该活动已截止')
      //       return
      //     }
      //   })
      //   return
      // }
      this.$router.push({ name: "checkout", query: { type: 2 } });

    },
    // onLoad() {
    //   this.page++;
    //   this.getCartlist().then((cartlist) => {
    //     let checked = [];
    //     cartlist.basketResponseDtos.map((v) => {
    //       if (v.checked == true) {
    //         checked.push(v.id);
    //       }
    //     });
    //     this.checkedGoods = this.checkedGoods.concat(checked);
    //     this.goods = this.goods.concat(cartlist.basketResponseDtos);

    //     this.loading = false;
    //     if (cartlist.count <= 10 * this.page) {
    //       this.finished = true;
    //     }
    //   });
    // },
    // onRefresh() {
    //   // 清空列表数据
    //   this.page = 1;
    //   this.finished = false;
    //   // 重新加载数据
    //   // 将 loading 设置为 true，表示处于加载状态
    //   this.loading = true;
    //   this.goods = [];
    //   this.isLoading = true;
    //   this.getCartlist().then((cartlist) => {
    //     setTimeout(() => {
    //       this.isLoading = false;
    //     }, 500);
    //     if (cartlist.basketResponseDtos.length !== 0) {
    //       let checked = [];
    //       cartlist.basketResponseDtos.map((v) => {
    //         if (v.checked == true) {
    //           checked.push(v.id);
    //         }
    //       });
    //       this.checkedGoods = checked;
    //       this.goods = cartlist.basketResponseDtos;
    //       this.loading = false;
    //     } else {
    //       this.goods = [];
    //     }
    //     if (cartlist.count < 10 * this.page) {
    //       this.finished = true;
    //       this.loading = false;
    //     }
    //     //
    //     this.refreshing = true;
    //     this.onLoad();
    //   });
    // },
    init () {
      this.invalidGoods()
      this.isLoading = true;
      this.firstLoading = true;
      this.page = 1;
      this.goods = [];
      this.getCartlist().then((cartlist) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        this.updateUserCartQuantity(cartlist.length);
        let checked = [];
        let cartlistAvailable = [];
        let cartlistUnabled = [];

        if (cartlist.length !== 0) {
          cartlist.map((v) => {
            if (v.checked == true && v.isEnable == true) {
              checked.push(v.id);
            }
            // isEnable true 是上架商品 false是下架商品
            if (v.isEnable == true) {
              cartlistAvailable.push(v);
            }
            if (v.isEnable == false) {
              cartlistUnabled.push(v);
            }
          });
          console.log(
            this.cartlistAvailable,
            cartlistUnabled,
            cartlist,
            "cartlistAvailable"
          );
          this.checkedGoods = checked;
          this.cartlistAvailable = cartlistAvailable;
          if (cartlistAvailable.length !== 0) {
            var goodsId = [];
            cartlistAvailable.map((v) => {
              goodsId.push(v.goodsId);
            });
            console.log(goodsId, "vvvv");
            this.GetLimitGoods(goodsId);
          }
          this.cartlistUnabled = cartlistUnabled;
          this.goods = cartlist;
        } else {
          this.goods = [];
        }
        console.log(
          this.cartlistAvailable,
          cartlistUnabled,
          cartlist,
          "cartlistAvailable"
        );
        this.checkedGoods = checked;
        this.cartlistAvailable = cartlistAvailable;
        this.cartlistUnabled = cartlistUnabled;
        this.goods = cartlist;
        this.loading = false;
        this.firstLoading = false;
      });
    },
    getCartlist () {
      return new Promise((resolve, reject) => {
        service
          .getCart()
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            // reject();
          });
      });



    },
    invalidGoods () {
      service.CleanInvalidGoods().then(res => {
      })
    }
  },
  mounted () {
    this.page = 1;
    this.pageSize = 10;
    // this.invalidGoods()
    this.init();
    // 购物车数量接口暂时废弃
    // service.getCartNumber().then((res) => {
    //   this.updateUserCartQuantity(res.data);
    // });
  },
};
</script>

<style lang="less">
.cartContainer {
  width: 100%;
  // height: calc(100% - 27.5vw);
  min-height: 100vh;
  overflow-x: hidden; //更改滑动
  background: #f7f7f7;

  .deleteAll {
    margin-left: 2vw;
    color: #ee0a24;
  }

  .delete-button {
    height: 100%;
    width: 17vw;
  }

  .van-overlay {
    z-index: 102;
  }

  .van-card {
    .van-card__desc {
      width: 42vw;
    }
  }

  .flex-around {
    height: 32px;
    color: #929292;
    background-color: #f3f3f3;
    font-size: 12px;
  }

  .cartTip {
    width: 1.2vw;
    height: 1.2vw;
    border-radius: 50%;
    background: #ee0a24;
    margin-right: 4px;
  }

  .van-card:not(:first-child) {
    margin-top: 0;
  }

  .van-card__content {
    width: 56vw;
  }

  // .van-card__title {
  //   padding-top: 9px;
  // }
  .van-submit-bar {
    bottom: 16.6vw;
    padding-bottom: 0 !important;
  }

  // .van-card__num {
  //   // 改动购物车加减位置
  //   margin-top: -1vw;
  // }

  .van-checkbox__icon {
    width: 18px;
    height: 18px;
  }

  .van-checkbox__icon .van-icon {
    width: 18px;
    height: 18px;
    line-height: 18px;
    margin-right: 14px;
  }

  .van-checkbox__label {
    width: 100%;
    height: auto;
    box-sizing: border-box;
  }

  // .card-goods {
  //   padding: 10px 0;
  //   background-color: #fff;
  //   margin-bottom: 10vw;
  .packageActive {
    display: flex;
    justify-content: space-between;
    padding: 2vw 4vw;
    font-size: 3.2vw;
    border-bottom: 1px solid #f8f8f8;
    align-items: center;
    background: #fff;
    margin-top: 2vw;
  }

  .van {
    &-checkbox {
      .van-checkbox__label {
        width: 100%;
      }
    }
  }

  &__item {
    position: relative;
    background-color: #fafafa;

    .van-checkbox__label {
      width: 100%;
      height: auto; // temp
      // padding: 0 10px 0 15px;
      box-sizing: border-box;
    }

    .van-checkbox__icon {
      top: 50%;
      left: 10px;
      z-index: 1;
      position: absolute;
      margin-top: -10px;
    }

    .van-card__content {
      width: 55vw;
    }

    .van-card__price {
      color: #f44;
    }
  }
}

.clearGoods {
  padding: 2vw 4vw;
  // margin-top: 2vw;
  // border-bottom: 2vw solid #f7f7f7;
}

// }
// .scroll {
//   height: calc(100% - 2.1vw);
// }
.cartList {
  // padding: 0 4vw;
  // background: #fff;
  //
  overflow: auto;
  padding-bottom: 34vw;

  .list-item {
    // padding: 2vw 4vw;
    background: #fff;
    // border-bottom: 1px solid #f8f8f8;
    // height: 33.07vw;
  }

  .card-goods {
    display: flex;

    .van-card {
      background: #fff;
      padding: 10px 0 10px 14px;
    }
  }
}

.index {
  &-empty {
    // height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &-box {
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
    }
  }
}

// css style
.list-item {
  position: relative;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}

.list-item[data-type='0'] {
  transform: translate3d(0, 0, 0);
}

.list-item[data-type='1'] {
  transform: translate3d(-17vw, 0, 0);
}

.list-item:after {
  content: ' ';
  position: absolute;
  left: 0.2rem;
  bottom: 0;
  right: 0;
  height: 1px;
  border-bottom: 1px solid #ccc;
  color: #ccc;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  z-index: 2;
}

.list-item .title {
  display: block;
  color: #333;
  overflow: hidden;
  font-size: 15px;
  margin-left: 28px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-item .center {
  display: block;
  font-size: 12px;
  position: absolute;
  left: 40%;
  top: 2rem;
  color: #666;
}

.list-item .delete {
  width: 17vw;
  height: 100%;
  /* padding: 0.2rem; */
  background: #ee0a24;
  font-size: 12px;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 0;
  right: -17vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
